import { render, staticRenderFns } from "./project_list_item_delayed_deletion_modal_footer.vue?vue&type=template&id=40380933"
import script from "./project_list_item_delayed_deletion_modal_footer.vue?vue&type=script&lang=js"
export * from "./project_list_item_delayed_deletion_modal_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports